<template>
  <div class="badges">
    <div class="badges__single badges__single--is-new" v-if="is_new">
      {{ translations.new }}
    </div>
    <div class="badges__single badges__single--is-on-sale" v-if="is_on_sale">
      <span v-if="discount_percentage">{{ discount_percentage }}%</span>
      <span v-else="">%</span>
    </div>
    <div class="badges__single badges__single--is-top" v-if="is_top">
      {{ translations.top }}
    </div>
    <div class="badges__single badges__single--is-out-of-stock" v-if="is_out_of_stock">
      {{ translations.outOfStock }}
    </div>
  </div>
</template>

<script>
export default {
  name: "WellsBadges",
  props: {
    is_new: Boolean,
    is_on_sale: Boolean,
    discount_percentage: Number,
    is_top: Boolean,
    is_out_of_stock: Boolean
  },
  data() {
    return {
      translations: {
        new: ws_vue_store.translations.badges.new,
        top: ws_vue_store.translations.badges.top,
        outOfStock: ws_vue_store.translations.badges.out_of_stock
      }
    };
  }
};
</script>

<style scoped lang="scss">
.badges {
  &__single {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    color: #fff;
    font-weight: 500;
    line-height: 1;
    font-size: 1.2rem;
    text-transform: uppercase;
    vertical-align: middle;
    text-align: center;
    border-radius: 5rem;
    box-shadow: 0 0.4rem 0.6rem 0 rgba(0, 0, 0, 0.09);
  }
}
</style>
